export default Object.freeze({
  LOGIN_REDIRECT_URI: 'login_redirect_uri',
  IS_LOGGED_IN: 'is_logged_in'
})
